import type { Answer } from "@pulse/api/answersAPI";
import useQuestionResponse from "../../useQuestionResponse";
import { useTranslation } from "react-i18next";

function Counter() {
    const { t } = useTranslation();
    const { answers } = useQuestionResponse();
    return (
        <div className="flex flex-col items-center w-fit gap-5 mr-8 lg:mr-20">
            <div className="text-5xl">{answers.length}</div>
            <div>{t("responseOverview.responses")}</div>
        </div>
    );
}

function TextResponseItem({ answer }: { answer: Answer }) {
    return (
        <div className="flex items-start gap-1 rounded-[3px] border border-compendia-border bg-surface-subtle px-4 py-3 font-light italic">
            <span>&quot;</span>
            <p className="truncate">{answer.answerValue}</p>
            <span>&quot;</span>
        </div>
    );
}

export default function TextResponseContent() {
    const { answers } = useQuestionResponse();
    return (
        <div className="flex items-center justify-between mx-8 lg:mx-20">
            <Counter />
            <div className="grid grid-cols-1 gap-3 pb-2 lg:grid-cols-2">
                {answers.slice(0, 8).map((answer, idx) => (
                    <TextResponseItem key={idx} answer={answer} />
                ))}
            </div>
        </div>
    );
}
